export const aboutText = {
  en: {
    section: "My Approach",
    title: "Holistic & Culturally-Aware",

    notJustTitle: "I believe that career guidance is not just about:",
    notJust: ["Choosing a job that’s hiring", "Choosing a “hot” industry"],

    aligningTitle: "It’s about aligning:",
    aligning: [
      "Your personality",
      "Your values",
      "Your strengths",
      "Your culture and background",
      "Your current health and capacity",
      "Your stage of life",
    ],

    perspectiveTitle: "I bring the perspective of:",
    perspective: [
      "Someone who once chose the wrong major",
      "Someone who has worked across different fields",
      "A mother who has experienced career breaks",
      "An immigrant who has started over from the beginning",
    ],
  },

  vi: {
    section: "Phương Pháp",
    title: "Toàn Diện & Thấu Hiểu Văn Hoá",

    notJustTitle: "Tôi tin rằng định hướng nghề nghiệp không chỉ là:",
    notJust: [
      "Chọn một công việc đang tuyển",
      "Chạy theo một ngành đang “hot”",
    ],

    aligningTitle: "Mà là sự kết nối giữa:",
    aligning: [
      "Tính cách của bạn",
      "Giá trị sống",
      "Điểm mạnh cá nhân",
      "Văn hoá và xuất thân",
      "Sức khoẻ và năng lượng hiện tại",
      "Giai đoạn cuộc sống",
    ],

    perspectiveTitle: "Tôi mang đến góc nhìn của:",
    perspective: [
      "Người từng chọn sai ngành học",
      "Người đã làm việc qua nhiều lĩnh vực",
      "Một người mẹ từng gián đoạn sự nghiệp",
      "Một người nhập cư bắt đầu lại từ con số không",
    ],
  },
};
